<template>
  <CardContainer>
    <v-container>
      <v-layout
        align-center
        class="forgotpassword--confirmation"
        justify-center
        row>
        <v-flex xs12>
          <v-layout row wrap>
            <v-flex xs12 class="text-xs-center">
              <v-icon class="forgotpassword--confirmation-icon">mail_outline</v-icon>
              <h2 class="forgotpassword--confirmation-title">
                Check your inbox for an email with username and password info
              </h2>
            </v-flex>

            <v-flex xs12 class="forgotpassword--confirmation-divider">
              <hr />
            </v-flex>

            <v-flex xs12 class="forgotpassword--confirmation-content">
              <p>If the email has been sent and you do not see it in your inbox yet,
                please be sure to check in your spam or junk mail folder.</p>
              <p>If after trying this you still do not have success, please send an email to
                <a href="mailto:support@homegauge.com">support@homegauge.com</a>
                explaining your problem and we will be glad to help you out.</p>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </CardContainer>
</template>

<script>
import CardContainer from '@/components/CardContainer.vue';

export default {
  components: { CardContainer },
};
</script>

<style lang="scss" scoped>
@import '../styles/vars/theme';
@import '../styles/vars/typography';

.forgotpassword--confirmation {
  &-content {
    p {
      font-size: 1rem;
      line-height: 1.7rem;
      font-weight: $typography-weight-semibold;
      margin: 0 0 25px;
    }
  }

  &-divider {
    padding: 40px 0;

    hr {
      border: none;
      border-top: 2px solid rgb(211, 211, 211);
    }
  }

  &-icon {
    color: $theme-color-primary;
    font-size: 7.5rem;
    margin: 0 0 5px;
  }

  &-title {
    font-size: 1.15rem;
    font-weight: $typography-weight-semibold;
    letter-spacing: -0.0125rem;
  }
}
</style>
